import { Core } from '@springtree/eva-services-core';
import productDetailState from './product-detail-state.js';
import buildServiceState from '../../builders/build-service-state.js';
const productDetailProductPricesState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailProductPrices',
    service: Core.GetProductPrices,
    beforeRequest: ({ req, get }) => {
        const currentProduct = get(productDetailState.response);
        const productId = currentProduct && currentProduct.Result?.product_id;
        if (!productId) {
            return;
        }
        const newRequest = {
            ...req,
            ProductIDs: [productId],
        };
        return newRequest;
    },
});
export default productDetailProductPricesState;
//# sourceMappingURL=product-detail-product-prices-state.js.map